// Config starter code
import { createChatBotMessage } from "react-chatbot-kit";

const config = {
  initialMessages: [createChatBotMessage(`Hello! Welcome to Meerana. Please feel free to ask me any questions related to Meerana products and services. I'm here to assist you!`)],
  botName: 'Meerana Bot',
}

export default config